import blog from './blog'
import fileAndDocuments from './file-and-documents'

export default {
  name: 'Blog',
  path: 'blog',
  meta: {
    label: 'blog',
    auth: 'blog'
  },
  component: {
    name: 'Blog',
    render(c) {
      return c('router-view')
    }
  },
  children: [blog, fileAndDocuments]
}
